import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavBarTab } from '../../nav-bar.model';

@Component({
    standalone: false,
    selector: 'mibi-nav-bar-login-view',
    templateUrl: './login-view.component.html',
    styleUrls: ['./login-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBarLoginViewComponent {
    @Input() tab!: NavBarTab;
    @Input() isAlternativeWelcomePage!: boolean;
    @Output() login = new EventEmitter<void>();

    onLogin() {
        this.login.emit();
    }
}
